export const bundleConstants = {

  /*********
   꾸러미 신청 검색조건 변경
   **********/
  SELECT_SEARCH_REQUEST: 'SELECT_SEARCH_REQUEST',

  /*********
   꾸러미 신청 목록 조회
   **********/
  BUNDLE_REQUEST: 'GET_BUNDLE_REQUEST',
  BUNDLE_SUCCESS: 'GET_BUNDLE_SUCCESS',
  BUNDLE_FAILURE: 'GET_BUNDLE_FAILURE',

  /*********
   꾸러미 신청 상세 조회
   **********/
  DETAIL_REQUEST: 'GET_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'GET_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'GET_DETAIL_FAILURE',

  /*********
   꾸러미 신청 상세선택
   **********/
  SELECT_REQUEST: 'SELECT_BUNDLE_REQUEST',

  /***********
   꾸러미 신청 히스토리 관리
   ************/
  BUNDLE_HISTORY: 'SET_BUNDLE_HISTORY',

}
